<select class="selectpicker form-control" :id="elementId" data-live-search="true" :data-size="sizeOfOptions" v-model="selectedValue" title="Nothing selected"
        :disabled="disabled"
        @change="onSelectValueChange" >
    <option v-for="option in selectOptions" :value="option.id" v-if="!listIsStringsOnly">
        {{option.text}}
    </option>
    <option v-for="option in selectOptions" :value="option" v-if="listIsStringsOnly">
        {{option}}
    </option>
</select>